<template>
  <div class="d-flex align-items-center">

    <!-- Fullscreen Image Modal -->
    <div v-if="selectedImage" class="fullscreen-overlay" @click.self="closeImage">
      <!-- Close Button -->
      <div class="close-btn" @click="closeImage">
        &times;
      </div>

      <!-- Image Container -->
      <div class="image-container">
        <img
            :src="selectedImage.imageUrl"
            class="fullscreen-image"
            alt="Full Screen Image"
        >
      </div>
    </div>

    <!-- Thumbnails Grid -->
    <div v-for="(item, idx) in items" :key="idx" class="mx-1">
      <div
          class="thumbnail-wrapper cursor-pointer border rounded shadow"
          @click="setSelectedImage(item)"
      >
        <img
            :src="item.imageUrl"
            alt="Thumbnail"
            class="thumbnail-img"
        >
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'OrderMediaHolder',
  props: {
    items: {
      type: Array
    }
  },
  data() {
    return {
      selectedImage: null,
    }
  },
  methods: {
    async setSelectedImage(item) {
      this.selectedImage = JSON.parse(JSON.stringify(item));
      document.body.style.overflow = 'hidden';
    },
    async closeImage() {
      this.selectedImage = null;
      document.body.style.overflow = 'auto';
    }
  }
}
</script>

<style scoped>
.thumbnail-wrapper {
  height: 10rem;
  width: 10rem;
  overflow: hidden;
  background-color: #fff;
  transition: transform 0.2s;
}

.thumbnail-wrapper:hover {
  transform: scale(1.05);
  border-color: #007bff;
}

.thumbnail-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.fullscreen-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.85);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeIn 0.3s ease-in-out;
}

.image-container {
  max-width: 95%;
  max-height: 95%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.fullscreen-image {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
  box-shadow: 0 0 20px rgba(0,0,0,0.5);
  border-radius: 4px;
}
.close-btn {
  position: absolute;
  top: 20px;
  right: 30px;
  color: #fff;
  font-size: 40px;
  font-weight: bold;
  cursor: pointer;
  z-index: 10000;
  transition: color 0.3s;
  line-height: 1;
}

.close-btn:hover {
  color: #ff4d4d;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>